import { Input, Output, ElementRef, Component, OnInit, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'tog-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss']
})
export class DropdownComponent implements OnInit {
  currentValue: string = '';
  placeholder: string = '';

  @Input() initialText = '';
  @Input() control: FormControl;
  @Input() height: string;
  @Input() isDisabled: boolean = false;
  @Output() onChange = new EventEmitter();
  constructor(private _el: ElementRef) { }

  ngOnInit() {
    this.placeholder = this.initialText;
    let self = this;

    // Initial text
    setTimeout(() => {
      if (self.control != undefined) {
        if (!self.control.value) {
          let initialListener = this.control.valueChanges.subscribe((text) => {
            if (text) {
              self.updateDataElement(text);
              if (initialListener) {
                initialListener.unsubscribe();
              }
            }
          });
        } else {
          self.updateDataElement(self.control.value);
        }
      }
    }, 0);


    // Set listeners for ng-content elements
    self._el.nativeElement.onclick = function(e) {
       if(e.target.nodeName.toLowerCase() === 'li' &&
         self.currentValue !== e.target.dataset.value) {
         self.currentValue = e.target.dataset.value;
         if (self.control != undefined) {
           self.control.setValue(e.target.dataset.value);
           self.control.markAsDirty();
         }
         self.placeholder = e.target.innerText;
         self.onChange.emit(e.target.dataset.value)
       }
    }
  }

  @Input() set reset(cache: boolean) {
    // if (cache) {
    //   this.currentValue = '';
    //   this.placeholder = this.initialText;
    //   this.onChange.emit(this.currentValue);
    // }
  }

  @Input() set initialValue(value: any) {
    this.updateDataElement(value);
  }

  updateDataElement(value: any) {
    let li = this._el.nativeElement.querySelector('li[data-value="' + value + '"]');
    if (li) {
      setTimeout((self) => {
        self.currentValue = li.dataset.value;
        self.placeholder = li.innerText;
      }, 0, this);
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/components/dropdown/dropdown.component.ts